// Toast notifications (Plan 1 `ui.js` `TDS.toast`). Global singleton state rendered by ToastHost.vue
// (mounted once in App.vue), exposed through this composable so any component/store can call toast().
import { reactive } from 'vue'

export interface ToastItem {
  id: number
  message: string
  kind: 'ok' | 'err' | ''
}

const toasts = reactive<ToastItem[]>([])
let seq = 0

export function useToast() {
  function toast(message: string, kind: ToastItem['kind'] = ''): void {
    const id = ++seq
    toasts.push({ id, message, kind })
    setTimeout(() => {
      const i = toasts.findIndex((t) => t.id === id)
      if (i >= 0) toasts.splice(i, 1)
    }, 2800)
  }
  return { toasts, toast }
}
